import { render, staticRenderFns } from "./CommissionStatusProgress.vue?vue&type=template&id=20ee4980&"
import script from "./CommissionStatusProgress.vue?vue&type=script&lang=js&"
export * from "./CommissionStatusProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports